import React from "react";
import Navbar from "../Components/Navbar";
import TitleTop from "../Components/TitleTop";
import { useRef } from "react";
import About from "../Components/About";
import ValueProp from "../Components/ValueProp";
import Contact from "../Components/Contact";
function LandingPage() {
  

  const contactRef = useRef(null);

  return (
    <>
      <div>
        <div className="bg-dark fixed-top">
          <Navbar contactRef={contactRef}/>
        </div>
        <TitleTop /> <br />
        <br />
        <ValueProp />
        <Contact ref={contactRef}/>

      </div>
    </>
  );
}

export default LandingPage;
